import fr from 'element-ui/lib/locale/lang/fr';

// 法语(法国)
export default {
  ...fr,
  layout: {
    title: 'Se connecter avec un ID Uniportal',
    tip: 'Les numéros de téléphone non enregistrés seront automatiquement enregistrés après la connexion réussie',
    line: 'Autres options de connexion',
  },
  button: {
    submit: "Connexion/S'inscrire",
    getCode: 'Obtenir un code',
    emailRegister: "S'inscrire avec une adresse e-mail",
    w3Login: 'Connexion au compte W3',
    employeeLogin: 'Connexion des employés',
    passwordLogin: 'Connexion par mot de passe',
    reSend: 'Renvoyer',
    problem: 'Aide en ligne',
    privacyPolicy: 'Politique de confidentialité',
  },
  placeholder: {
    phoneNumber: 'Numéro de téléphone portable',
    verificationCode: 'Code de vérification SMS',
  },
  dialog: {
    imgCode: "Saisissez les caractères sur l'image.",
    userAgreements: {
      header: 'Accord utilisateur et Déclaration relative à la vie privée',
      text1: 'Veuillez lire et accepter les {privacy} et {agreement}.',
      text2:
        "Lorsque vous accédez à l'application Huawei à l'étranger, les informations personnelles seront transmises aux filiales de Huawei à l'étranger pour traitement. Pour plus de détails, voir {privacy}",
    },
    crossBorder: {
      header: "Conseils d'autorisation",
      text: "Le service local que vous utilisez n'est pas situé dans la même région que le lieu d'enregistrement de votre compte. L'accès transfrontalier aux informations de compte nécessite votre autorisation.",
    },
    multiAccounts: 'Sélectionnez un compte.',
    agreeButton: 'Accepter et continuer',
    disagreeButton: 'Refuser',
    confirmButton: 'Confirmer',
    cancelButton: 'Annuler',
    knowMe: 'OK',
  },
  toast: {
    hasSend: 'Le code de vérification a été envoyé.',
    wait: "Un instant, s'il vous plaît",
  },
  tooltip: {
    Huawei: 'Compte Huawei',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'Le code CAPTCHA doit être renseigné.',
    'IDC-03-0002': 'Le code CAPTCHA a expiré.',
    'IDC-00-0004': 'Le code CAPTCHA est incorrect.',

    // 表单输入为空
    'IDC-01-00024':
      "L'indicatif du pays est requis pour vérifier votre numéro de téléphone portable.",
    phoneNumberEmpty: 'Saisissez le numéro de téléphone portable.',
    'IDC-03-00033': 'Saisissez le code de vérification SMS.',

    // 表单数据错误
    'IDC-02-00227': 'Le numéro de portable saisi ne correspond pas au pays/région sélectionné',
    'IDC-02-00226': 'Indicatif du pays interdit',
    'IDC-02-00029': 'Le code de vérification est incorrect ou a expiré.',
    'IDC-02-0013': "Échec de la connexion SMS en raison d'une erreur de code de vérification.",
    'IDC-02-0020': 'Échec de la vérification. Le code de vérification est incorrect.',
    'IDC-02-00028': 'Le numéro de téléphone mobile doit être une chaîne de 6 à 30 chiffres.',
    'IDC-02-00012': 'Numéro de téléphone portable incorrect.',

    // 错误操作锁定
    accountLock:
      'Numéro de téléphone portable ou code de vérification incorrect. {number} tentatives restantes. | Numéro de téléphone portable ou code de vérification incorrect. {number} tentatives restantes.',
    accountLocked:
      'Trop de tentatives ont échoué. Veuillez réessayer dans {number} secondes. | Trop de tentatives ont échoué. Veuillez réessayer dans {number} secondes.',
    operationRisk:
      "L'opération en cours présente des risques pour la sécurité. Veuillez réessayer dans {number} secondes.",

    // 频繁操作
    'IDC-02-00038': 'Veuillez réessayez dans 60 secondes.',
    'IDC-02-00064':
      'Vous envoyez des codes de vérification SMS trop fréquemment. Veuillez réessayer dans 24 heures.',
    'IDC-02-00211':
      "L'opération en cours présente des risques pour la sécurité. Veuillez réessayer plus tard.",
    'IDC-02-00212':
      'Votre numéro de téléphone mobile envoie des codes de vérification SMS trop fréquemment. Veuillez changer votre numéro de téléphone mobile ou réessayer 24 heures plus tard.',
    'IDC-02-00213':
      'Vous envoyez des codes de vérification SMS trop fréquemment. Veuillez réessayer dans 24 heures.',
    'IDC-02-00215':
      'Votre numéro de téléphone mobile envoie des codes de vérification SMS trop fréquemment. Veuillez changer votre numéro de téléphone mobile, choisir un autre mode de vérification ou réessayer 24 heures plus tard.',
    'IDC-02-00228':
      'Vous envoyez des codes de vérification SMS trop fréquemment. Veuillez réessayer 1 heure plus tard.',
    'IDC-02-00092':
      "L'opération en cours est trop fréquente. Veuillez réessayer 24 heures plus tard.",

    // 请求异常
    'IDC-10-00400': 'La demande du client est anormale.',
    'IDC-10-00500': 'Erreur interne du système. ',
    'IDC-02-00264': "Les demandes d'accès non autorisées sont interdites",
    'IDC-02-00063': 'Paramètre non valide.',
    'IDC-03-0007':
      "L'opération présente un risque de sécurité et ne peut pas être enregistrée pour le moment.", // 机翻
    'IDC-03-00057': "L'opération en cours présente des risques de sécurité.",

    // 页面过期
    'IDC-00-00017': 'La page a expiré.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Revenir',
  closeButton: 'Fermer',

  // 滑块验证相关：
  resourceReqFailed: 'La demande de ressources a échoué. Actualisez la page et réessayez.',
  verifyFailedAndPlsRetry: 'Échec de la vérification. Veuillez réessayer.',
  serviceErrAndPlsRetry: 'Exception de service. Veuillez réessayer.',
  learnMore: 'En savoir plus',
  cookieBannerText:
    'Ce site utilise des cookies pour vous offrir la meilleure expérience utilisateur possible.',
};
